<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate/>
    <!--    <v-list-item v-if="!loading && !list.length">-->
    <!--      <v-list-item-icon>-->
    <!--        <v-icon>mdi-tag-multiple-outline</v-icon>-->
    <!--      </v-list-item-icon>-->
    <!--      <v-list-item-title>برچسب ها</v-list-item-title>-->
    <!--    </v-list-item>-->

    <!--    <template v-else-if="!!list.length">-->
    <template v-if="!isBtn">
      <v-card-title>
        دفترچه تلفن
      </v-card-title>
      <v-divider class="my-0"/>
    </template>

    <template v-for="(tag, i) in list">
      <v-hover :key="tag.id" v-slot="{hover}">
        <v-list-item :link="!!picker" @click="handleSelection(tag)">
          <v-list-item-icon class="align-self-center">
            <v-icon>mdi-{{ isInShareListPhonebook(tag) ? 'share-all' : 'tag'}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ tag.name }}</v-list-item-title>
          <template v-if="hover && !picker">
            <v-list-item-action v-if="hasPhonebookPermission('edit', tag)" class="mx-1">
              <v-btn icon small @click.stop="editingTag(tag)">
                <v-icon small>mdi-pencil-outline</v-icon>
              </v-btn>
            </v-list-item-action>

            <v-list-item-action v-if="hasPhonebookPermission('delete', tag)" class="mx-1">
              <v-btn icon small @click.stop="deleteTag(tag.id)">
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>

          <v-card-actions v-else-if="!!picker && tagInList(tag.id)">
            <v-icon color="blue lighten-2">mdi-check</v-icon>
          </v-card-actions>
        </v-list-item>
      </v-hover>
    </template>
    <v-divider v-if="!isBtn" class="ma-0"/>

    <v-list-item>
      <v-list-item-content>
        <v-btn v-if="!canSubmit" class="rounded-lg" color="#FF4400" dark depressed large min-width="250"
               @click="dialog = true">
          <v-icon left>mdi-account-box-outline</v-icon>
          افزودن دفترچه تلفن
        </v-btn>

        <v-btn v-else class="rounded-lg" color="success" outlined @click="submitTags">
          اعمال تغییرات
        </v-btn>
      </v-list-item-content>
    </v-list-item>
    <!--    </template>-->

    <custom-popup v-model="dialog" :cons="{title: 'ایجاد دفترچه تلفن جدید'}" hide-confirm max-width="400"
                  @close="closeDialog">
      <v-card flat>
        <v-card-title>
          نام مورد نظر خود را وارد نمایید
        </v-card-title>

        <v-card-text>
          <v-text-field v-model="tagName" autofocus clear-icon="mdi-close-circle-outline" clearable dense
                        hide-details label="دفترچه تلفن" outlined @keydown.enter="addTag"/>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn class="rounded-lg white--text" color="red" depressed @click="closeDialog">
            انصراف
          </v-btn>
          <v-btn :loading="loading" class="rounded-lg" color="green" dark depressed @click="addTag">
            <span v-if="canEdit">ویرایش</span>
            <span v-else>ذخیره</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
export default {
  name: "contactsTags",

  props: {
    picker: Boolean,
    tagList: Array,
    immediate: Boolean,
    isBtn: Boolean
  },

  data: () => ({
    dialog: false,
    editedTag: {},
    loading: false,
    list: [],
    tagName: '',
    tempTags: []
  }),

  created() {
    this.fetchTags()
  },

  computed: {
    canEdit() {
      return !!this.editedTag && !!Object.keys(this.editedTag)?.length
    },
    canSubmit() {
      return this.picker
        ? this.tempTags.sort(function (a, b) {
        return a.id - b.id
      }).join(',') !== this.tagList.sort(function (a, b) {
        return a.id - b.id
      }).join(',')
        : false
    }
  },

  // watch: {
  //   tagList(val) {
  //     this.tempTags.concat(val)
  //   }
  // },

  methods: {
    fetchTags(callReload = false) {
      this.loading = true

      this.requestApiGetPayamak('phoneTag')
        .then(({data}) => {
          this.list = data.data
          this.$emit('update:tagList', data.data)

          if (this.picker) {
            let arr = this.tagList.map(t => t.id)
            this.tempTags = data.data.filter(item => arr.includes(item.id))
          }

          if (callReload)
            this.$emit('reload')
        })
        .catch(({response}) => console.log('failed in get phone tags: ', response))
        .finally(() => this.loading = false)
    },
    addTag() {
      let tags = this.list.map(item => item.name.trim());
      if (tags.includes(this.tagName.trim())) return this.$toast.error('نام تکراری میباشد');

      if (this.canEdit) {
        this.updateTag();
        return;
      }
      this.loading = true

      this.requestApiPostPayamak('phoneTag/store', {
        name: this.tagName
      })
        .then(({data}) => {
          this.$toast.success('برچسب با موفقیت اضافه شد.');
          this.fetchTags(true)
          this.$emit('reload')
          this.closeDialog()
        })
        .catch(({response}) => console.log('failed in store tag: ', response))
        .finally(() => this.loading = false)
    },
    deleteTag(id) {
      this.loading = true

      this.requestApiPostPayamak('contact/deleteTag', {
        phoneTag: id
      })
        .then(({data}) => {
          this.$toast.success('برچسب با موفقیت حذف شد');
          this.fetchTags(true)
          this.closeDialog()
        })
        .catch(({response}) => console.log('failed to delete tag: ', response))
        .finally(() => this.loading = false)
    },
    editingTag(tag) {
      this.editedTag = tag
      this.tagName = tag.name
      this.dialog = true
    },
    updateTag() {
      this.loading = true

      this.requestApiPostPayamak(`phoneTag/update/${this.editedTag.id}`, {
        name: this.tagName
      })
        .then(({data}) => {
          this.$toast.success('برچسب با موفقیت ویرایش شد');
          this.fetchTags(true)
          this.closeDialog()
        })
        .catch(({response}) => console.log('failed to delete tag: ', response))
        .finally(() => this.loading = false)
    },
    closeDialog() {
      this.tagName = ''
      this.dialog = false
      this.editedTag = {}
    },
    tagInList(id) {
      return !!this.tempTags.find(item => item.id === id)
    },
    handleSelection(tag) {
      if (!this.picker) return

      let arr = this.tempTags

      if (!!arr.find(item => item.id === tag.id)) {
        let index = arr.findIndex(item => item.id === tag.id);
        arr.splice(index, 1);
      } else {
        arr.push(tag);
      }

      this.tempTags = arr
    },
    submitTags() {
      let arr = []
      arr = arr.concat(this.tempTags)

      if (this.immediate) {
        this.$emit('submitTag', arr);
        this.$root.$emit('submitTag', arr)
      }

      // this.
    }
  }
}
</script>

<style scoped>

</style>